import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AuthentificationService} from '../../providers/authentification-service';
import { AngularFire, FirebaseListObservable} from 'angularfire2';
import {PreferencesService} from '../../providers/preferences-service';
import{MenusService} from '../../providers/menus-service';

@Component({
  selector: 'page-preferences',
  templateUrl: 'preferences.html'
})
/*
  Generated class for the Preferences page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
  La page préférénces contient les paramètres de l'application plus les favoris de l'utilisateur
*/
export class PreferencesPage {
    public pushNotificationsToggled: boolean;//Boolean qui indique si le toggle des notifications push est actif ou non
    private menusFavoris: FirebaseListObservable<any[]>;//FirebaseListObservable qui contient les menus favoris d'un utilisateur
    
    //Constructeur de la page preferences.ts
    constructor(public navCtrl: NavController,		
                public authentificationService: AuthentificationService,	
                public af: AngularFire,
                public preferencesService:PreferencesService,
                public menusService:MenusService) 
                {
                    this.bindFavoriteMenus();
                    this.bindNotificationToggle();
                }
 //On bind la variable menusFavoris à ce qu'on reçoit du menusService
  bindFavoriteMenus()
  {
      if(this.authentificationService.getLogged())
      {
          this.menusFavoris=this.menusService.getFavoriteMenus();
      }
  }
  //Appelé lorsque la vue est loadée (affichée)
  ionViewDidLoad() {
    this.bindFavoriteMenus();
  }
  //On bind la valeur du toggle et son comportement
  bindNotificationToggle() 
  {
    var isPushAuthorized = localStorage.getItem('isPushAuthorized');
    var deviceOwner = localStorage.getItem('deviceOwner');
    console.log('preferences.ts => isPushAuthorized = ', isPushAuthorized);
    if(deviceOwner === null || deviceOwner === "null" || isPushAuthorized === null || isPushAuthorized === "false" )
        this.pushNotificationsToggled = false;
    else
      this.pushNotificationsToggled = true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/preferences/preferences.ts